"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStringifiedFeatureSwitches = exports.useIdentifyUser = exports.useFeatureSwitchContext = exports.useIsInContext = exports.useFeatureSwitches = exports.useFeatureFlag = void 0;
const react_1 = require("react");
const context_1 = require("./context");
const useFeatureFlag = (featureName) => {
    const ctx = react_1.useContext(context_1.FeatureSwitchContext);
    if (!ctx)
        return false;
    return ctx.featureSwitches?.[featureName];
};
exports.useFeatureFlag = useFeatureFlag;
const useFeatureSwitches = () => {
    const { featureSwitches } = react_1.useContext(context_1.FeatureSwitchContext);
    return featureSwitches;
};
exports.useFeatureSwitches = useFeatureSwitches;
const useIsInContext = () => {
    const ctx = react_1.useContext(context_1.FeatureSwitchContext);
    return !!ctx;
};
exports.useIsInContext = useIsInContext;
const useFeatureSwitchContext = () => {
    return react_1.useContext(context_1.FeatureSwitchContext);
};
exports.useFeatureSwitchContext = useFeatureSwitchContext;
const useIdentifyUser = () => {
    const { flagManager } = react_1.useContext(context_1.FeatureSwitchContext);
    return (userId) => flagManager.identifyUser(userId);
};
exports.useIdentifyUser = useIdentifyUser;
const useStringifiedFeatureSwitches = () => {
    const featureSwitches = exports.useFeatureSwitches();
    return JSON.stringify(featureSwitches);
};
exports.useStringifiedFeatureSwitches = useStringifiedFeatureSwitches;
